import BottomRow from '@/components/Menu/shared/BottomRow';
import styled from 'styled-components';
import MobileMenuItem from '@/components/Menu/mobile/MobileMenuItem';
import {useIsDesktop} from '@repo/ui';
import ExpandableBlock from '@/components/Menu/mobile/ExpandableBlock';

const StyledWrapper = styled.div`
	padding: 0 17px;
	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		padding: 0 30px;
	}

	@media (min-width: ${({ theme }) => theme?.breakpoints?.desktop || 1024}px) and (orientation: landscape) {
		display: none;
	}
`;

const StyledMenuItems = styled.div`
	margin-bottom: 50px;
	padding-top: 120px;
	display: flex;
	flex-direction: column;
	gap: 15px;

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		padding-top: 200px;
	}
`;

const MobileContent = ({ data, globals }) => {
	const menuItems = (data?.menuItems || []).slice(1, -1);
	const isDesktop = useIsDesktop();

	return (
		<StyledWrapper>
			<StyledMenuItems>
				{menuItems.map((item, index) => (
					<MobileMenuItem key={item?.id || index} item={item} />
				))}
			</StyledMenuItems>
			{!isDesktop && <BottomRow globals={globals} data={data} />}
			<ExpandableBlock data={data} globals={globals} />
		</StyledWrapper>
	);
};

export default MobileContent;